/**
 * 删除左右两端的空格
 * @param {string} str
 * @returns {string}
 */
export function strTrim (str) {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 格式化字符串
 * @param {Number} pIndex
 * @param {Number} aIndex
 * @param {string} val
 * @returns {string}
 */
export function formatStr (pIndex, aIndex, val) {
  let str = strTrim(val)
  str = str.split('')
  let newStr = ''
  str.map((item, index) => {
    if (index < pIndex || index > aIndex - 1) newStr += item
    else newStr += '*'
  })
  return newStr
}

/**
 * 时长
 * @param {number} date
 * @returns {string}
 */
export function formatDuration (date) {
  const oldTime = new Date(date).getTime()
  const nowTime = new Date().getTime()
  const times = (nowTime - oldTime) / 1000
  if (times < 60) {
    return `${times}秒`
  } else if (times < 3600) {
    return `${Math.floor(times / 60)}分钟`
  } else if (times < 3600 * 24) {
    return `${Math.floor(times / 3600)}小时`
  } else if (times >= 3600 * 24) {
    return `${Math.floor(times / (3600 * 24))}天`
  } else {
    return ''
  }
}

/**
 * @param {Object} arr
 * @returns {Object}
 */
export function arrToObj (arr) {
  const obj = {}
  if (Object.prototype.toString.call(arr) === '[object Array]') {
    if (arr.length > 0) {
      arr.forEach(item => {
        obj[item.value] = item.text
      })
    }
  }
  return obj
}

/**
 * 时间格式转换
 * @param {string} date
 * @param {boolean} onlyDate
 * @returns {string}
 */
export function comGetTime (date = new Date(), onlyDate = true) {
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let day = date.getDate()
  day = day > 9 ? day : '0' + day
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds()
  second = second > 9 ? second : '0' + second
  let milli = date.getMilliseconds()
  milli = milli > 100 ? milli : milli > 10 ? '0' + milli : '00' + milli
  return onlyDate ? `${year}-${month}-${day}` : `${year}${month}${day}${hour}${minute}${second}${milli}`
}

// export function toChinesNum (num) {
//   const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
//   const unit = ['', '十', '百', '千', '万']
//   num = parseInt(num)
//   const getWan = (temp) => {
//     const strArr = temp.toString().split('').reverse()
//     let newNum = ''
//     for (var i = 0; i < strArr.length; i++) {
//       newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
//     }
//     return newNum
//   }
//   const overWan = Math.floor(num / 10000)
//   let noWan = num % 10000
//   if (noWan.toString().length < 4) noWan = '0' + noWan
//   return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
// }
/**
 * @function noEmpty 为空判断
 * @param {String} val
 * @returns {Object}
 */
export function noEmpty (val) {
  if (val === null || val === undefined || val === '') {
    return false
  } else return true
}



// WEBPACK FOOTER //
// ./src/utils/index.js